import { addMinutes as dateFnsAddMinutes } from 'date-fns';
import parseDate from './parseDate';

const addMinutes = (dateTime, minutes) => {
  const parsedDateTime = parseDate(dateTime);

  return parsedDateTime ? dateFnsAddMinutes(parsedDateTime, minutes) : null;
};

export default addMinutes;
